module.exports = __webpack_public_path__ + "img/dg_icon_1.eb176bb8.png";